import React, { useEffect, useState } from "react";
import { PageHeader } from "../../components/Shell";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { QRCodeCanvas } from "qrcode.react";
import { Download, Printer } from "lucide-react";
import QRPrintCard from "../../components/QRPrintCard";

export default function MemberQR() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/me/qr").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const download = () => {
    const c = document.getElementById("my-qr-canvas");
    if (!c) return;
    const url = c.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = `dlshs-qr-${(user?.name || "member").replace(/\s+/g, "_")}.png`;
    a.click();
  };

  const print = () => window.print();

  return (
    <div data-testid="member-qr-page">
      <PageHeader eyebrow="Member" title="My attendance QR" />

      <div className="grid md:grid-cols-2 gap-6">
        <div className="grid place-items-center">
          {data ? (
            <QRPrintCard
              qrCanvasId="my-qr-canvas"
              qrValue={data.qr_token}
              memberName={user?.name || ""}
              memberCode={user?.member_code || ""}
              organizationName={user?.organization_name || ""}
              size={240}
              QRComponent={QRCodeCanvas}
            />
          ) : (
            <div className="h-[300px] grid place-items-center text-[#5a6663]">Loading…</div>
          )}
        </div>
        <div className="no-print">
          <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#05126E] mb-2">
            Your attendance QR
          </div>
          <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight mb-4 text-[#0f1a14]">
            Show this at school events
          </h2>
          <p className="text-sm text-[#5a6663] mb-6">
            Your QR contains a secure random token only — no personal data.
            Only Org Admins of your organization can scan it.
          </p>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={download}
              disabled={!data}
              className="px-5 py-2.5 rounded-md bg-[#05126E] text-white font-semibold hover:bg-[#030B45] disabled:opacity-50 flex items-center gap-2 transition-colors"
              data-testid="dl-my-qr"
            >
              <Download className="w-4 h-4" /> Download PNG
            </button>
            <button
              onClick={print}
              disabled={!data}
              className="px-5 py-2.5 rounded-md border border-[#0f1a14] text-[#0f1a14] font-semibold hover:bg-[#0f1a14] hover:text-white disabled:opacity-50 flex items-center gap-2 transition-colors"
              data-testid="print-my-qr"
            >
              <Printer className="w-4 h-4" /> Print ID card
            </button>
          </div>
          {data && (
            <div className="mt-6 rounded-md border border-[#E3E6E4] bg-white p-4">
              <div className="text-[10px] uppercase tracking-widest text-[#5a6663]">
                Token
              </div>
              <div className="mono text-xs break-all mt-1 text-[#0f1a14]">
                {data.qr_token}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
